import React from "react";
import BaseModel from "../models/BaseModel";
import BaseModelMap from "../models/BaseModelMap";
import TreeViewModel from "../models/TreeviewModel";
import Logger from "../Logger";
import TopologyLevel from "../models/Line";
import TreeMenuIcon from "../components/NavigationTree2/TreeMenuIcon";
import type Device from "../models/Device";
import { getDuplicatePhysicalAdressDevices, renumberAllphysicalAddresses } from "../models/Device";
import { itx } from "../translationItx/itx";
import ConfirmDialog from "../modelDialogs/ConfirmDialog";
import BaseDialog from "../modelDialogs/BaseDialog";

const logger = new Logger();

export default class TopologiesTreeViewModel extends TreeViewModel {
  constructor(obj: BaseModel) {
    super(obj);
  }

  get typedObj(): BaseModelMap<TopologyLevel> {
    return this.obj as BaseModelMap<TopologyLevel>;
  }
  get isSelectable(): boolean {
    return false;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    state.updateAreas(false);
    return state.topologies.sortIntBy("tag");
  }

  checkIfDuplicatePhysicalErros() {
    // after renumbering, check for duplicates and flag errors and show errors in Dialog
    const duplicates = getDuplicatePhysicalAdressDevices();
    function ShowDuplicatesDialog(props: { duplicatesFound: Array<Device> }) {
      const { duplicatesFound } = props;

      return (
        <BaseDialog
          title={itx(
            "topologiesTreeViewModel.duplicatePhysicalAddressFound",
            "Doppelte physikalischen Adressen gefunden",
          )}
          noAbortButton={true}
        >
          <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "16px" }}>
            {/* Warnung Header */}
            <div
              style={{
                padding: "12px",
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "4px",
                color: "#664d03",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span style={{ fontSize: "20px" }}>⚠️</span>
              <span style={{ fontWeight: "500" }}>
                {itx(
                  "topologiesTreeViewModel.duplicatePhysicalAddressFound",
                  "Folgende Geräte haben doppelte physikalische Adressen:",
                )}
              </span>
            </div>

            {/* Geräte Liste */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                maxHeight: "300px",
                overflowY: "auto",
                padding: "8px",
              }}
            >
              {duplicatesFound.map((device, index) => (
                <div
                  key={index}
                  style={{
                    padding: "10px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    borderRadius: "3px",
                    fontFamily: "monospace",
                    fontSize: "13px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#495057",
                  }}
                >
                  <span style={{ fontWeight: "500", color: "#212529" }}>
                    {device.fullTag} {device.name}
                  </span>
                  <span style={{ color: "#dc3545" }}>{device.fullPhysicalAddress}</span>
                </div>
              ))}
            </div>

            {/* Fehler Nachricht */}
            <div
              style={{
                padding: "12px",
                backgroundColor: "#f8d7da",
                border: "1px solid #f5c6cb",
                borderRadius: "4px",
                color: "#721c24",
                fontSize: "13px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span style={{ fontSize: "18px" }}>❌</span>
              <span>
                {itx(
                  "topologiesTreeViewModel.duplicatePhysicalAddressNotAllowed",
                  "Dies ist nicht erlaubt. Bitte setze die Adressen korrekt.",
                )}
              </span>
            </div>
          </div>
        </BaseDialog>
      );
    }
    if (duplicates.length > 0) {
      // show error dialog with list of duplicates and option to auto renumber
      state.dialogManager.openDialog(<ShowDuplicatesDialog duplicatesFound={duplicates} />);
      return true;
    }
    return false;
  }

  getButtons(): JSX.Element[] | undefined {
    const res = new Array<any>();

    res.push(
      <TreeMenuIcon
        onClick={() => {
          state.dialogManager.openDialog(
            <ConfirmDialog
              title={itx("topologiesTreeViewModel.createAllAdressesNew", "Alle Adressen neu erzeugen")}
              text={itx(
                "topologiesTreeViewModel.createAllAdressesNewQuestion",
                "Sollen alle physikalischen Adressen neu erzeugt werden?",
              )}
              onOk={() => {
                renumberAllphysicalAddresses();
                if (this.checkIfDuplicatePhysicalErros()) {
                  return false;
                } else {
                  return true;
                }
              }}
              onAbort={() => {
                return true;
              }}
              onClose={() => {
                return true;
              }}
            />,
            true,
          );
        }}
        iconName="sort-numeric-down" // no itx
        // tooltipKey={tooltipKey}
        tooltipText={itx("topologiesTreeViewModel.createAllAdressesNew", "Alle Adressen neu erzeugen")}
        objName="renumber"
        key="renumber"
      />,
    );

    return res;
  }
}
